import React from 'react';
import { useQuery } from '@apollo/client';
import { UserFlagIdentifierType } from '../types';
import FetchUserFlagQuery from './FetchUserFlagQuery';

type result = {
  loading: boolean;
  flag?: boolean;
};

interface IFetchUserFlagConnectorApollo {
  children: (result: result) => React.ReactElement;
  identifier: UserFlagIdentifierType;
}

const FetchUserFlagConnectorApollo: React.FC<IFetchUserFlagConnectorApollo> = ({
  children,
  identifier,
}) => {
  const { loading, error, data } = useQuery(FetchUserFlagQuery, {
    variables: { identifier: identifier },
  });

  const result: any = {
    loading,
  };

  if (error) throw error;

  if (!loading) {
    result.flag = Boolean(data.me.flags.getOne);
  }

  return children(result);
};

export default FetchUserFlagConnectorApollo;
